var _linearGradient, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient0, _linearGradient2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-4.502953659537916 -1.816370980454367 85.1080168931947 83.43087708452362",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2378,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.898,
    x2: 0.066,
    y1: 0.155,
    y2: 0.931
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#ffe847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#ffc830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#ff8b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#ff672a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#e31587"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 67.813,
    cy: 8.879,
    gradientUnits: "userSpaceOnUse",
    r: 80.797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#ffbd4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#ffac31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#ff9d17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#ff563b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#ff3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f5156c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#eb0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#e50080"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 38.289,
    cy: 41.911,
    gradientUnits: "userSpaceOnUse",
    r: 80.797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960e18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#b11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#db293d",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#f5334b",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ff3750",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 48.03,
    cy: -9.457,
    gradientUnits: "userSpaceOnUse",
    r: 58.534
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#ffdc3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#ff9d12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#ff980e"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 29.352,
    cy: 63.016,
    gradientUnits: "userSpaceOnUse",
    r: 38.471
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3a8ee6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5c79f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c139e6"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: -7935.62,
    cy: -8491.546,
    gradientTransform: "matrix(.972 -.235 .275 1.138 10091.302 7833.798)",
    gradientUnits: "userSpaceOnUse",
    r: 20.397
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8c4ff3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716a8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6e008b",
    stopOpacity: 0.6
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 37.269,
    cy: 5.573,
    gradientUnits: "userSpaceOnUse",
    r: 27.676
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#ffdb27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#ffc82a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ffa930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#ff7e37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#ff7139"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 59.023,
    cy: -11.981,
    gradientUnits: "userSpaceOnUse",
    r: 118.081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#ff5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#e31587"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: -7927.165,
    cy: -8522.859,
    gradientTransform: "matrix(.105 .995 -.653 .069 -4684.004 8470.191)",
    gradientUnits: "userSpaceOnUse",
    r: 86.499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ffe847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#ffc830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#ff8b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#ff672a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#e31587"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 36.617,
    cy: 15.824,
    gradientUnits: "userSpaceOnUse",
    r: 73.72
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#ff5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#e31587"
  }))), _radialGradient0 || (_radialGradient0 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 56.077,
    cy: 20.139,
    gradientUnits: "userSpaceOnUse",
    r: 80.686
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#ffe141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#ffaf1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#ff980e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0.888,
    x2: 0.18,
    y1: 0.151,
    y2: 0.835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#fff44f",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#fff44f",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff44f",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff44f",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.62 26.83c-1.7-4.06-5.1-8.43-7.78-9.8a40.27 40.27 0 0 1 3.93 11.75v.07C66.4 17.92 58.97 13.52 52.9 3.92c-.32-.48-.62-.97-.92-1.48-.17-.3-.3-.56-.43-.8A7.05 7.05 0 0 1 50.97.1a.1.1 0 0 0-.08-.1.14.14 0 0 0-.1 0v.02c0 .02-.03 0-.03 0V0c-9.72 5.7-13.03 16.26-13.33 21.53a19.4 19.4 0 0 0-10.67 4.12 11.6 11.6 0 0 0-1-.76 17.97 17.97 0 0 1-.1-9.5 28.7 28.7 0 0 0-9.34 7.22c-1.55-1.94-1.44-8.36-1.35-9.7a6.93 6.93 0 0 0-1.3.68 28.23 28.23 0 0 0-3.8 3.25 33.84 33.84 0 0 0-3.6 4.35 32.73 32.73 0 0 0-5.2 11.74L1 33.2c-.07.33-.34 2.04-.38 2.4v.1A36.94 36.94 0 0 0 0 41.04v.2a38.76 38.76 0 0 0 76.95 6.56c.07-.5.12-1 .18-1.5a39.86 39.86 0 0 0-2.5-19.47zM29.95 57.16c.18.1.35.2.53.27l.03.02q-.27-.14-.55-.3zm40.83-28.32v-.03.04z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.62 26.83c-1.7-4.06-5.1-8.43-7.78-9.8a40.27 40.27 0 0 1 3.93 11.75v.08a35.1 35.1 0 0 1-1.2 26.16c-4.44 9.53-15.2 19.3-32.03 18.82-18.18-.5-34.2-14-37.2-31.68-.54-2.8 0-4.2.28-6.47A28.88 28.88 0 0 0 0 41.03v.2a38.76 38.76 0 0 0 76.95 6.56c.07-.5.12-1 .18-1.5a39.86 39.86 0 0 0-2.5-19.47z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.62 26.83c-1.7-4.06-5.1-8.43-7.78-9.8a40.27 40.27 0 0 1 3.93 11.75v.08a35.1 35.1 0 0 1-1.2 26.16c-4.44 9.53-15.2 19.3-32.03 18.82-18.18-.5-34.2-14-37.2-31.68-.54-2.8 0-4.2.28-6.47A28.88 28.88 0 0 0 0 41.03v.2a38.76 38.76 0 0 0 76.95 6.56c.07-.5.12-1 .18-1.5a39.86 39.86 0 0 0-2.5-19.47z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.78 31.38c.1.06.16.12.24.18a21.1 21.1 0 0 0-3.6-4.7C40.38 14.82 49.27.74 50.77.03V0c-9.72 5.7-13.03 16.26-13.33 21.53.45-.03.9-.06 1.36-.06a19.56 19.56 0 0 1 16.98 9.9z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.83 33.8c-.07.95-3.47 4.28-4.67 4.28-11.02 0-12.8 6.66-12.8 6.66.48 5.62 4.4 10.24 9.12 12.7l.66.3q.57.25 1.14.47a17.23 17.23 0 0 0 5.04.98c19.32.9 23.06-23.1 9.12-30.07a13.38 13.38 0 0 1 9.34 2.28 19.56 19.56 0 0 0-16.98-9.9c-.46 0-.9.02-1.36.05a19.4 19.4 0 0 0-10.67 4.12c.6.5 1.26 1.16 2.67 2.55 2.63 2.6 9.37 5.27 9.4 5.6z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.83 33.8c-.07.95-3.47 4.28-4.67 4.28-11.02 0-12.8 6.66-12.8 6.66.48 5.62 4.4 10.24 9.12 12.7l.66.3q.57.25 1.14.47a17.23 17.23 0 0 0 5.04.98c19.32.9 23.06-23.1 9.12-30.07a13.38 13.38 0 0 1 9.34 2.28 19.56 19.56 0 0 0-16.98-9.9c-.46 0-.9.02-1.36.05a19.4 19.4 0 0 0-10.67 4.12c.6.5 1.26 1.16 2.67 2.55 2.63 2.6 9.37 5.27 9.4 5.6z",
    fill: "url(#f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.97 24.36c.3.2.57.37.8.53a17.97 17.97 0 0 1-.1-9.5 28.7 28.7 0 0 0-9.34 7.22c.2 0 5.8-.1 8.64 1.74z",
    fill: "url(#g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M.35 42.16c3 17.67 19 31.17 37.2 31.68 16.83.48 27.58-9.3 32.02-18.82a35.1 35.1 0 0 0 1.2-26.16v-.04-.04l.02.07c1.36 8.98-3.2 17.67-10.34 23.55l-.03.05c-13.9 11.33-27.2 6.84-29.9 5q-.3-.13-.57-.28c-8.1-3.87-11.46-11.26-10.74-17.6a9.95 9.95 0 0 1-9.18-5.77 14.62 14.62 0 0 1 14.25-.57 19.3 19.3 0 0 0 14.54.57c-.02-.32-6.76-3-9.4-5.6-1.4-1.38-2.06-2.04-2.66-2.54a11.6 11.6 0 0 0-1-.76c-.23-.16-.48-.33-.8-.53-2.82-1.84-8.44-1.74-8.63-1.74h-.02c-1.53-1.94-1.43-8.36-1.34-9.7a6.93 6.93 0 0 0-1.3.68 28.23 28.23 0 0 0-3.8 3.26 33.84 33.84 0 0 0-3.63 4.34 32.73 32.73 0 0 0-5.2 11.74c-.02.08-1.4 6.1-.72 9.22z",
    fill: "url(#h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.43 26.86a21.1 21.1 0 0 1 3.6 4.7c.2.17.4.33.58.48 8.8 8.1 4.2 19.55 3.85 20.37 7.13-5.88 11.7-14.57 10.33-23.55-4.4-10.93-11.82-15.33-17.9-24.93-.3-.48-.6-.97-.9-1.48-.17-.3-.3-.56-.43-.8A7.05 7.05 0 0 1 50.97.1a.1.1 0 0 0-.08-.1.14.14 0 0 0-.1 0v.02c0 .02-.03 0-.03 0-1.5.72-10.4 14.8 1.66 26.84z",
    fill: "url(#i)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6 32.04c-.17-.16-.37-.32-.58-.48l-.24-.18a13.38 13.38 0 0 0-9.35-2.27c13.94 6.98 10.2 31-9.12 30.08a17.23 17.23 0 0 1-5.03-.97q-.57-.2-1.14-.46c-.22-.1-.43-.2-.65-.3h.03c2.7 1.84 16 6.34 29.92-5l.02-.04c.35-.8 4.95-12.27-3.84-20.36z",
    fill: "url(#j)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.35 44.74s1.8-6.66 12.8-6.66c1.2 0 4.6-3.33 4.68-4.3a19.3 19.3 0 0 1-14.56-.56 14.62 14.62 0 0 0-14.25.57 9.95 9.95 0 0 0 9.2 5.76c-.73 6.34 2.62 13.73 10.73 17.6.18.1.35.18.53.27-4.73-2.45-8.64-7.07-9.13-12.7z",
    fill: "url(#k)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.62 26.83c-1.7-4.06-5.1-8.43-7.78-9.8a40.27 40.27 0 0 1 3.93 11.75v.07C66.4 17.92 58.97 13.52 52.9 3.92c-.32-.48-.62-.97-.92-1.48-.17-.3-.3-.56-.43-.8A7.05 7.05 0 0 1 50.97.1a.1.1 0 0 0-.08-.1.14.14 0 0 0-.1 0v.02c0 .02-.03 0-.03 0V0c-9.72 5.7-13.03 16.26-13.33 21.53.45-.03.9-.06 1.36-.06a19.56 19.56 0 0 1 16.98 9.9 13.38 13.38 0 0 0-9.34-2.26c13.94 6.98 10.2 31-9.12 30.08a17.23 17.23 0 0 1-5.04-.97q-.57-.2-1.14-.46l-.66-.3h.03q-.27-.13-.55-.28c.18.1.35.2.53.27-4.73-2.45-8.64-7.07-9.13-12.7 0 0 1.8-6.65 12.8-6.65 1.2 0 4.6-3.33 4.68-4.3-.02-.3-6.76-3-9.4-5.58-1.4-1.4-2.07-2.05-2.66-2.55a11.6 11.6 0 0 0-1-.76 17.97 17.97 0 0 1-.1-9.5 28.7 28.7 0 0 0-9.34 7.22c-1.55-1.94-1.44-8.36-1.35-9.7a6.93 6.93 0 0 0-1.3.68 28.23 28.23 0 0 0-3.8 3.25 33.84 33.84 0 0 0-3.6 4.35 32.73 32.73 0 0 0-5.2 11.74L1 33.2c-.07.33-.4 2.07-.45 2.44a45.1 45.1 0 0 0-.57 5.4v.2a38.76 38.76 0 0 0 76.95 6.56c.07-.5.12-1 .18-1.5a39.86 39.86 0 0 0-2.5-19.47zm-3.85 2v.03z",
    fill: "url(#l)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.da0970fa77774fe1035a6b93dbc09557.svg";
export { ForwardRef as ReactComponent };